import createAction from '../create-action'
import { ApiDispatch } from '@types'
import {
  SET_CURRENTLY_DISPLAYED_USERS,
  SET_CURRENTLY_DISPLAYED_USERS_FAILURE,
} from '@store/action-list'
import { apiAction } from '@store/actions/api'

export const setCurrentlyDisplayedUsersSuccess = createAction(
  SET_CURRENTLY_DISPLAYED_USERS,
)
export const setCurrentlyDisplayedUsersFailure = createAction(
  SET_CURRENTLY_DISPLAYED_USERS_FAILURE,
)

export const fetchDisplayedUsers = (
  page: number,
  pageSize: number,
  filters = {},
): ApiDispatch => {
  return apiAction({
    url: '/p4/users',
    method: 'GET',
    params: {
      limit: pageSize,
      offset: pageSize * page,
      ...filters,
    },
    actionCallbacks: {
      success: setCurrentlyDisplayedUsersSuccess,
      failure: setCurrentlyDisplayedUsersFailure,
    },
  })
}
